export default {
    list: [],
}
